import React from "react";
import senselogo from "../Sections/images/SENSE.png";
import hplogo from "../Sections/images/hp.png";
import startupIndialogo from "../Sections/images/startupIndia.png";
import startupKarlogo from "../Sections/images/startupKar.png";
import gokLogo from "../Sections/images/GoK.png";
import KnKLogo from "../Sections/images/KnK.png";
import vidhiiLogo from "../Sections/images/Vidhii.png";
import companyservices from "../Sections/images/companyservices.png";
import MSMELogo from "../Sections/images/MSME.png";

function CompanyData() {
  return (
    <div id="companydata">
      <div className="fourthheader">
        <div>WHAT IS IT</div>
        <div>THAT WE DO?</div>
      </div>
      <div className="companycontent">
        <div className="companycontent-left">
          <div className="company-tagline">
            TRANSCENDING DIGITAL TRANSFORMATION
          </div>
          <div className="company-writeup">
            At SEΠSE, through our Channel partners, we pride ourselves as being
            the pioneers in developing solutions to address global pressing
            issues. We intend to imbibe Deep Science through Technology as the
            platform to ensure that our clients and partners are provided with
            the best experience to identify and attain triumph through our
            projects.
          </div>
          <div className="channel-partner">
            <div className="senselogo">
              <img src={senselogo} alt="logo" className="senselogo" />
            </div>
            <div className="channelpartner-with">With</div>
            <div className="partner-logos">
              <img src={hplogo} alt="hplogo" className="partnerlogo" />
            </div>
            <div className="partner-logos">
              <img src={KnKLogo} alt="KnK" className="partnerlogo" />
              <img src={vidhiiLogo} alt="Vidhii" className="partnerlogo" />
            </div>
            <div className="partner-logos">
              <img
                src={startupIndialogo}
                alt="startupIndia"
                className="partnerlogo"
              />
              <img
                src={startupKarlogo}
                alt="startupKarnataka"
                className="partnerlogo"
              />
            </div>
            <div className="partner-logos">
              <img src={gokLogo} alt="GoK" className="goklogo" />
              <img src={MSMELogo} alt="MSME" className="goklogo" />
            </div>
          </div>
        </div>
        <div className="companycontent-right">
          <div className="companyservicesdiv">
            <img
              src={companyservices}
              alt="company services"
              className="companyservices"
            />
          </div>
          <div className="company-writeup-list">
            <span className="list-elem">Web Development</span>
            <span className="list-elem">Application Development</span>
            <span className="list-elem">Big Data Analytics</span>
            <span className="list-elem">Artifical Intelligence</span>
            <span className="list-elem">Machine Learning</span>
            <span className="list-elem">Deep Learning</span>
            <span className="list-elem">Deep Science Modulation</span>
            <span className="list-elem">SaaS Development</span>
            <span className="list-elem">PaaS Development</span>
            <span className="list-elem">Immersive Creativity</span>
            <span className="list-elem">Bespoke Development</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyData;
